module.exports = __webpack_public_path__ + "static/junkkari-480x480-fd38ec8c219cc9f2bbafb6dc8ec4a64c.png";